module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/powered-eff55753a06946211d61e6b5d5a339b4.png";